import React from "react";
import theme from "@monorepo/styles/theme";
import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export const Loader = ({ size }: { size?: number }) => (
  <Box
    sx={{
      display: "grid",
      height: "100%",
      width: "100%",
      minWidth: "80px",
      minHeight: "80px",
      alignItems: "center",
      justifyItems: "center",
    }}
  >
    <CircularProgress classes={{ colorPrimary: `${theme.palette.primary.main}!important` }} size={size ? size : 50} />
  </Box>
);
